export const TABLE_ACTIONS = {
  SORT: 'sort',
  PAGINATE: 'paginate',
  FILTER: 'filter',
};

export const FILE_TYPES = [
  'application/pdf', // PDF
  'application/msword', // Word (doc)
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (docx)
  'application/vnd.ms-excel', // Excel (xls)
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel (xlsx)
  'text/plain',
  'text/csv',
];
export const IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
